import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

import { SelectedListToFilter, MultipleIdListToFilter } from '../../interfaces/reports/reports';
import { mustHaveOneRecord } from '@/validators/mustHaveOneRecord';
import { requireCheckboxesToBeCheckedValidator } from '../../validators/oneCheckBoxTobeChecked';

@Component({
  selector: 'app-filter-checkbox',
  templateUrl: './filter-checkbox.component.html',
  styleUrls: ['./filter-checkbox.component.css'],
})
export class FilterCheckboxComponent implements OnInit {
  @Input() filterTitle: string = '';
  @Input() gettingItemsList: boolean = false;
  @Input() gettingItemsListError: string = 'DEFAULT_VALUE';
  @Input() itemControls: FormArray = new FormArray([]);
  @Input() isRequired: boolean = true;
  @Input() filterResult: string = ''
  checkAllButton = new EventEmitter<boolean>();
  @Input() validateOneOfCheckbox: boolean = false
  // @Output() eventHandle = new EventEmitter<any>();
  @Input() listFilterAll: FormControl = new FormControl();
  @Input()
  get itemsList(): (SelectedListToFilter | MultipleIdListToFilter)[] {
    return this._itemsList;
  }
  set itemsList(itemsList: (SelectedListToFilter | MultipleIdListToFilter)[]) {
    if (itemsList) {
      if (itemsList.length > 0) {
        this._itemsList = itemsList;
        if (this.itemControls.controls.length > 0) {
          for (let index = this.itemControls.controls.length - 1; index >= 0; index--) {
            this.itemControls.removeAt(index);
          }
        }
        this._itemsList.map((item) => this.itemControls.push(new FormGroup({
          id: new FormControl(item.id),
          name: new FormControl(item.name),
          active: new FormControl(!!item.isActive),
          entryId: new FormControl(item.entryId || 0),
        })));
      }
    }
  }
  private _itemsList: (SelectedListToFilter | MultipleIdListToFilter)[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
  ) {

  }

  ngOnInit(): void {

  }

  getCheckFormControl(id: number): FormControl {
    let indexReq = -1;
    this.itemControls.value.some(({ id: rowIndex }: any, formArrayIndex: number) => {
      if (rowIndex === id) {
        indexReq = formArrayIndex;

      }
    });
    const formGroup = this.itemControls.at(indexReq) as FormGroup;
    return formGroup.controls.active as FormControl;
  }

  onCheckAll() {
    this.checkAllButton.emit();
  }

  onAllClicked() {
    this.listFilterAll.setValue(true);
  }

  asFormGroup(control: AbstractControl) {
    return control as FormGroup;
  }
}
